import { TableCard } from '../../../../components'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { FaturaAtendimentosTable } from './table/FaturaAtendimentosTable'
import { FaturaAtendimentosListHeader } from './components/header/FaturaAtendimentosListHeader'
import { FaturaAtendimentosInfoHeader } from './components/header/FaturaAtendimentosInfoHeader'

const FaturaAtendimentosList = () => {
  return (
    <>
      <FaturaAtendimentosInfoHeader />
      <TableCard>
        <FaturaAtendimentosListHeader />
        <FaturaAtendimentosTable />
      </TableCard>
    </>
  )
}

export const FaturaAtendimentosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <FaturaAtendimentosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
